/**
 * Generates a new key for the component.
 * Used to re-render an expand all or collapse all items.
 */
export const createNewKey = () => {
  return Math.random();
};
